import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AppShell from './components/AppShell'

const HomePage = lazy(() => import('./pages/HomePage'))
const NewsPage = lazy(() => import('./pages/NewsPage'))
const EventsPage = lazy(() => import('./pages/EventsPage'))
const CompaniesPage = lazy(() => import('./pages/CompaniesPage'))
const MarketsPage = lazy(() => import('./pages/MarketsPage'))
const DailyPage = lazy(() => import('./pages/DailyPage'))
const CommunityPage = lazy(() => import('./pages/CommunityPage'))
const CommunityPostPage = lazy(() => import('./pages/CommunityPostPage'))
const NewCommunityPostPage = lazy(() => import('./pages/NewCommunityPostPage'))

const loader = <div className="page-loader" role="status">正在装载商业航天情报…</div>

export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={loader}>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<HomePage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="companies" element={<CompaniesPage />} />
            <Route path="markets" element={<MarketsPage />} />
            <Route path="daily" element={<DailyPage />} />
            <Route path="community" element={<CommunityPage />} />
            <Route path="community/new" element={<NewCommunityPostPage />} />
            <Route path="community/:id" element={<CommunityPostPage />} />
            <Route path="search" element={<Navigate to="/news" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
